module.exports = __webpack_public_path__ + "static/media/ALARM-on.a9e84c1f.svg";